import React from 'react';
import { isEmpty, isNil } from 'lodash';
import { PlayCircleIcon } from '@metarouter-private/mr-mui';
import { useTrackWithUser } from '@ion/api';
import { useTestPipelineDrawerContext } from 'app/pipeline-details/StatusItem/TestPipelineDrawerContextProvider';
import { usePipelinePageContext } from 'app/pipeline-details/PipelinePageContextProvider';
import resolvePipelineConfiguration from 'app/shared/translation/pipelines/resolvePipelineConfiguration';
import isAllowedToTestPipeline from './isAllowedToTestPipeline';

const STATIC_PROPS = {
  startIcon: <PlayCircleIcon />,
  variant: 'outlined',
  color: 'secondary',
  'data-test-id': 'test-pipeline-button',
};

const MISSING_CONFIGURATION_TITLE =
  'You must have at least one integration, filter, or transformation to test your pipeline.';
const MISSING_PERMISSION_TITLE = 'You do not have permission to test pipelines.';

export default function useTestPipelineButtonProps() {
  const {
    drawer: { onOpen },
  } = useTestPipelineDrawerContext();
  const { pipeline } = usePipelinePageContext();
  const [trackTestPipelineDrawerLaunched] = useTrackWithUser('test_pipeline_drawer_launched');

  const onClick = () => {
    trackTestPipelineDrawerLaunched();
    onOpen();
  };

  const hasPermission = isAllowedToTestPipeline();
  const { filter, transform } = resolvePipelineConfiguration({
    deployedPipeline: pipeline.deployedPipeline,
    configuredPipeline: pipeline,
  });
  const hasTransformationConfiguration = !(isEmpty(pipeline.pipelineIntegrations) && isNil(filter) && isNil(transform));
  const disabled = !(hasPermission && hasTransformationConfiguration);

  let disabledTitle;
  if (!hasPermission) {
    disabledTitle = MISSING_PERMISSION_TITLE;
  } else if (!hasTransformationConfiguration) {
    disabledTitle = MISSING_CONFIGURATION_TITLE;
  }

  return {
    ...STATIC_PROPS,
    onClick,
    disabled,
    disabledTitle,
  };
}
